import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation';
import { useSubscribeAll } from '@atlassian/conversation-assistant-pubsub';
const ignoredEvents = new Set(['editor-context-payload']);

/**
 * This component listens to all pubsub events emitted
 * for specific events, it will call `onEventTriggersChatOpen`
 *
 * Example use case: if Rovo chat is closed in Confluence sidebar
 * and there is a reading-aids follow up triggering 'chat-new' pubsub event
 * We want to open the chat, and create a new conversation following that
 *
 * This component will be responsible to handle opening the chat, by calling `onEventTriggersChatOpen`
 * Each product will pass their own callback on how to open chat
 */
export const ChatOpenerSubscriber = ({
  onTriggerOpeningChat
}) => {
  const {
    sendAnalyticsEvent
  } = useAnalytics();
  useSubscribeAll(({
    type,
    source
  }) => {
    const isEventShouldNotTriggerOpeningChat = ignoredEvents.has(type);
    sendAnalyticsEvent({
      action: 'eventReceived',
      actionSubject: 'aiMatePubSubEvent',
      source,
      attributes: {
        publisherSource: source,
        payloadType: type,
        eventTriggersChatOpen: !isEventShouldNotTriggerOpeningChat
      }
    });
    if (isEventShouldNotTriggerOpeningChat) {
      return;
    }
    onTriggerOpeningChat();
  });
  return null;
};